/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Noachievementsforsetextra4Inputs */

const id_sandboxes_noachievementsforsetextra4 = /** @type {(inputs: Sandboxes_Noachievementsforsetextra4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ini mungkin berarti pencapaian belum tersedia saat ini tetapi akan ditambahkan di masa mendatang.`)
};

const ms_sandboxes_noachievementsforsetextra4 = /** @type {(inputs: Sandboxes_Noachievementsforsetextra4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ini mungkin bermakna pencapaian tidak tersedia buat masa ini tetapi akan ditambah pada masa hadapan.`)
};

const da_sandboxes_noachievementsforsetextra4 = /** @type {(inputs: Sandboxes_Noachievementsforsetextra4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dette kan betyde at achievements ikke er tilgængelige i øjeblikket, men vil blive tilføjet i fremtiden.`)
};

const de_sandboxes_noachievementsforsetextra4 = /** @type {(inputs: Sandboxes_Noachievementsforsetextra4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dies könnte bedeuten, dass die Errungenschaften derzeit nicht verfügbar sind, aber in Zukunft hinzugefügt werden.`)
};

const en_us2_sandboxes_noachievementsforsetextra4 = /** @type {(inputs: Sandboxes_Noachievementsforsetextra4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This could mean that the achievements are not currently available but will be added in the future.`)
};

const es_es2_sandboxes_noachievementsforsetextra4 = /** @type {(inputs: Sandboxes_Noachievementsforsetextra4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esto podría significar que los logros no están disponibles actualmente pero se añadirán en el futuro.`)
};

const es_mx2_sandboxes_noachievementsforsetextra4 = /** @type {(inputs: Sandboxes_Noachievementsforsetextra4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esto podría significar que los logros no están disponibles actualmente pero se agregarán en el futuro.`)
};

const fil_sandboxes_noachievementsforsetextra4 = /** @type {(inputs: Sandboxes_Noachievementsforsetextra4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maaaring nangangahulugan ito na ang mga achievement ay hindi kasalukuyang available ngunit idadagdag sa hinaharap.`)
};

const fr_sandboxes_noachievementsforsetextra4 = /** @type {(inputs: Sandboxes_Noachievementsforsetextra4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cela peut signifier que les succès ne sont pas encore disponibles mais qu'ils seront ajoutés à l'avenir.`)
};

const it_sandboxes_noachievementsforsetextra4 = /** @type {(inputs: Sandboxes_Noachievementsforsetextra4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potrebbe significare che i risultati non sono attualmente disponibili ma verranno aggiunti in futuro.`)
};

const hu_sandboxes_noachievementsforsetextra4 = /** @type {(inputs: Sandboxes_Noachievementsforsetextra4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ez azt jelentheti, hogy a teljesítmények jelenleg nem érhetők el, de a jövőben hozzáadásra kerülnek.`)
};

const nl_sandboxes_noachievementsforsetextra4 = /** @type {(inputs: Sandboxes_Noachievementsforsetextra4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit kan betekenen dat de prestaties momenteel niet beschikbaar zijn maar in de toekomst worden toegevoegd.`)
};

const no_sandboxes_noachievementsforsetextra4 = /** @type {(inputs: Sandboxes_Noachievementsforsetextra4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dette kan bety at prestasjonene ikke er tilgjengelige for øyeblikket, men vil bli lagt til i fremtiden.`)
};

const pl_sandboxes_noachievementsforsetextra4 = /** @type {(inputs: Sandboxes_Noachievementsforsetextra4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Może to oznaczać, że osiągnięcia nie są obecnie dostępne, ale zostaną dodane w przyszłości.`)
};

const pt_br2_sandboxes_noachievementsforsetextra4 = /** @type {(inputs: Sandboxes_Noachievementsforsetextra4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isto pode significar que as conquistas não estão disponíveis atualmente, mas serão adicionadas no futuro.`)
};

const pt_sandboxes_noachievementsforsetextra4 = /** @type {(inputs: Sandboxes_Noachievementsforsetextra4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isto pode significar que as conquistas não estão atualmente disponíveis, mas serão adicionadas no futuro.`)
};

const ro_sandboxes_noachievementsforsetextra4 = /** @type {(inputs: Sandboxes_Noachievementsforsetextra4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aceasta poate însemna că realizările nu sunt disponibile momentan, dar vor fi adăugate în viitor.`)
};

const fi_sandboxes_noachievementsforsetextra4 = /** @type {(inputs: Sandboxes_Noachievementsforsetextra4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tämä voi tarkoittaa, että saavutukset eivät ole tällä hetkellä saatavilla, mutta ne lisätään tulevaisuudessa.`)
};

const sv_sandboxes_noachievementsforsetextra4 = /** @type {(inputs: Sandboxes_Noachievementsforsetextra4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detta kan innebära att prestationerna inte är tillgängliga just nu men kommer att läggas till i framtiden.`)
};

const vi_sandboxes_noachievementsforsetextra4 = /** @type {(inputs: Sandboxes_Noachievementsforsetextra4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Điều này có thể có nghĩa là các thành tích hiện chưa khả dụng nhưng sẽ được thêm vào trong tương lai.`)
};

const tr_sandboxes_noachievementsforsetextra4 = /** @type {(inputs: Sandboxes_Noachievementsforsetextra4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu, başarımların şu anda mevcut olmadığı ancak gelecekte ekleneceği anlamına gelebilir.`)
};

const cs_sandboxes_noachievementsforsetextra4 = /** @type {(inputs: Sandboxes_Noachievementsforsetextra4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To může znamenat, že úspěchy nejsou aktuálně k dispozici, ale budou přidány v budoucnu.`)
};

const bg_sandboxes_noachievementsforsetextra4 = /** @type {(inputs: Sandboxes_Noachievementsforsetextra4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Това може да означава, че постиженията не са налични в момента, но ще бъдат добавени в бъдеще.`)
};

const ru_sandboxes_noachievementsforsetextra4 = /** @type {(inputs: Sandboxes_Noachievementsforsetextra4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Это может означать, что достижения в данный момент недоступны, но будут добавлены в будущем.`)
};

const uk_sandboxes_noachievementsforsetextra4 = /** @type {(inputs: Sandboxes_Noachievementsforsetextra4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Це може означати, що досягнення наразі недоступні, але будуть додані в майбутньому.`)
};

const ar_sandboxes_noachievementsforsetextra4 = /** @type {(inputs: Sandboxes_Noachievementsforsetextra4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قد يعني هذا أن الإنجازات غير متوفرة حاليًا ولكنها ستُضاف في المستقبل.`)
};

const hi_sandboxes_noachievementsforsetextra4 = /** @type {(inputs: Sandboxes_Noachievementsforsetextra4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इसका मतलब हो सकता है कि उपलब्धियाँ वर्तमान में उपलब्ध नहीं हैं लेकिन भविष्य में जोड़ी जाएँगी।`)
};

const th_sandboxes_noachievementsforsetextra4 = /** @type {(inputs: Sandboxes_Noachievementsforsetextra4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`นี่อาจหมายความว่าความสำเร็จยังไม่พร้อมใช้งานในขณะนี้ แต่จะถูกเพิ่มในอนาคต`)
};

const ja_sandboxes_noachievementsforsetextra4 = /** @type {(inputs: Sandboxes_Noachievementsforsetextra4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`実績が現在利用できないが、将来追加される可能性があります。`)
};

const zh_cn2_sandboxes_noachievementsforsetextra4 = /** @type {(inputs: Sandboxes_Noachievementsforsetextra4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这可能意味着成就当前不可用，但在未来会添加。`)
};

const zh_hant1_sandboxes_noachievementsforsetextra4 = /** @type {(inputs: Sandboxes_Noachievementsforsetextra4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這可能表示成就目前不可用，但在未來會新增。`)
};

const ko_sandboxes_noachievementsforsetextra4 = /** @type {(inputs: Sandboxes_Noachievementsforsetextra4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`현재 도전 과제를 사용할 수 없지만 향후 추가될 수 있습니다.`)
};

/**
* | output |
* | --- |
* | "This could mean that the achievements are not currently available but will be added in the future." |
*
* @param {Sandboxes_Noachievementsforsetextra4Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_noachievementsforsetextra4 = /** @type {((inputs?: Sandboxes_Noachievementsforsetextra4Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Noachievementsforsetextra4Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_noachievementsforsetextra4(inputs)
	if (locale === "ms") return ms_sandboxes_noachievementsforsetextra4(inputs)
	if (locale === "da") return da_sandboxes_noachievementsforsetextra4(inputs)
	if (locale === "de") return de_sandboxes_noachievementsforsetextra4(inputs)
	if (locale === "en-US") return en_us2_sandboxes_noachievementsforsetextra4(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_noachievementsforsetextra4(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_noachievementsforsetextra4(inputs)
	if (locale === "fil") return fil_sandboxes_noachievementsforsetextra4(inputs)
	if (locale === "fr") return fr_sandboxes_noachievementsforsetextra4(inputs)
	if (locale === "it") return it_sandboxes_noachievementsforsetextra4(inputs)
	if (locale === "hu") return hu_sandboxes_noachievementsforsetextra4(inputs)
	if (locale === "nl") return nl_sandboxes_noachievementsforsetextra4(inputs)
	if (locale === "no") return no_sandboxes_noachievementsforsetextra4(inputs)
	if (locale === "pl") return pl_sandboxes_noachievementsforsetextra4(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_noachievementsforsetextra4(inputs)
	if (locale === "pt") return pt_sandboxes_noachievementsforsetextra4(inputs)
	if (locale === "ro") return ro_sandboxes_noachievementsforsetextra4(inputs)
	if (locale === "fi") return fi_sandboxes_noachievementsforsetextra4(inputs)
	if (locale === "sv") return sv_sandboxes_noachievementsforsetextra4(inputs)
	if (locale === "vi") return vi_sandboxes_noachievementsforsetextra4(inputs)
	if (locale === "tr") return tr_sandboxes_noachievementsforsetextra4(inputs)
	if (locale === "cs") return cs_sandboxes_noachievementsforsetextra4(inputs)
	if (locale === "bg") return bg_sandboxes_noachievementsforsetextra4(inputs)
	if (locale === "ru") return ru_sandboxes_noachievementsforsetextra4(inputs)
	if (locale === "uk") return uk_sandboxes_noachievementsforsetextra4(inputs)
	if (locale === "ar") return ar_sandboxes_noachievementsforsetextra4(inputs)
	if (locale === "hi") return hi_sandboxes_noachievementsforsetextra4(inputs)
	if (locale === "th") return th_sandboxes_noachievementsforsetextra4(inputs)
	if (locale === "ja") return ja_sandboxes_noachievementsforsetextra4(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_noachievementsforsetextra4(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_noachievementsforsetextra4(inputs)
	return ko_sandboxes_noachievementsforsetextra4(inputs)
});
export { sandboxes_noachievementsforsetextra4 as "sandboxes.noAchievementsForSetExtra" }